import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import { Popconfirm } from "antd"
import Modal from "components/Modal/Modal"
import { PrimeButton } from "components-design-system"
import Checkbox from "components/Checkbox/Checkbox"

// hooks
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"

// styles
import "./ResultsTableDeleteModal.scss"

const ResultsTableDeleteModal = (props) => {
  const [deleteForAll, setDeleteForAll] = useState(false)
  let {
    id,
    header,
    showModal,
    setShowModal,
    onSubmit,
    onSubmitAlt = () => {},
    canDeleteFromAllRegistries,
    registrySpecific,
    hideOptions = false,
    width,
  } = props

  const { formView } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
    }))
  )

  const handleSubmit = () => {
    if (formView.id === "global") onSubmit(true)
    else onSubmit(deleteForAll)
    setDeleteForAll(false)
    setShowModal(false)
  }

  const handleSubmitAlt = () => {
    if (formView.id === "global") onSubmitAlt(true)
    else onSubmitAlt(deleteForAll)
    setDeleteForAll(false)
    setShowModal(false)
  }

  const isOutcomeMeasures = id === "outcome-measures"

  const popconfirmStyle = {
    maxWidth: 200,
  }

  const omActions = (
    <div className="action-container">
      <PrimeButton onClick={() => setShowModal(false)}>Cancel</PrimeButton>
      <Popconfirm
        title={<div style={popconfirmStyle}>Are you sure you want to delete data only?</div>}
        description={
          <div style={popconfirmStyle}>
            If you want this Outcome Measure to remain in the record, but are not ready to report Results, then "Delete
            Data Only". This action cannot be undone.
          </div>
        }
        onConfirm={handleSubmitAlt}
        placement="left"
        okType="danger"
        okText="Delete"
        width={320}
        cancelText="Cancel"
      >
        <PrimeButton danger>Delete Data Only</PrimeButton>
      </Popconfirm>

      <Popconfirm
        title={<div style={popconfirmStyle}>Are you sure you want to delete outcome measure?</div>}
        description={
          <div style={popconfirmStyle}>
            "Delete Outcome Measure" will completely remove this Outcome Measure from the record. Many CTG policies
            require Outcome Measures to be part of the registration record. This action cannot be undone.
          </div>
        }
        onConfirm={handleSubmit}
        placement="left"
        okType="danger"
        okText="Delete"
        width={320}
        cancelText="Cancel"
      >
        <PrimeButton danger>Delete Outcome Measure</PrimeButton>
      </Popconfirm>
    </div>
  )

  const renderGlobalActions = () => {
    if (isOutcomeMeasures) {
      return omActions
    }
    return (
      <div className="action-container">
        <PrimeButton onClick={() => setShowModal(false)}>Cancel</PrimeButton>
        <PrimeButton
          danger
          onClick={() => handleSubmit()}
        >
          Delete
        </PrimeButton>
      </div>
    )
  }

  const renderRegistryActions = () => {
    if (isOutcomeMeasures) {
      return omActions
    }

    return (
      <div className="action-container">
        <PrimeButton onClick={() => setShowModal(false)}>Cancel</PrimeButton>
        <PrimeButton
          danger
          onClick={() => handleSubmit()}
        >
          Delete
        </PrimeButton>
      </div>
    )
  }

  let view = formView.id
  if (formView.id === "eudra") view = "eudract"

  return (
    <Modal
      title={header}
      open={showModal}
      onCancel={() => setShowModal(false)}
      dialogClassName={"results-create-delete-modal"}
      footer={[]}
      destroyOnClose={true}
      type="delete-alt"
      width={width}
    >
      <div className="results-table-delete-modal-content-container">
        {formView.id === "global" ? (
          <>
            <div className="secondary-text">Deleting from Global view will delete items from all registries.</div>
            {renderGlobalActions()}
          </>
        ) : (
          <>
            <div className="checkbox-container">
              {registrySpecific !== true && hideOptions !== true && (
                <Checkbox
                  label={"Delete for all registries"}
                  disabled={canDeleteFromAllRegistries}
                  checked={deleteForAll}
                  onChange={(e) => setDeleteForAll(e.target.checked)}
                />
              )}
              {hideOptions !== true && (
                <Checkbox
                  label={`Delete for ${view?.toUpperCase()} only`}
                  disabled={true}
                  checked={true}
                />
              )}
            </div>
            {renderRegistryActions()}
          </>
        )}
      </div>
    </Modal>
  )
}

export default ResultsTableDeleteModal
